<script lang="ts">
  import type { UserSummary } from "$src/domain/users/UserSummary";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { HubService } from "$src/application/realtime/HubService";
  import { hubStore } from "$src/application/realtime/hubStore";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import { getContext } from "svelte";
  import { location } from "svelte-spa-router";

  let pageUrl = $location;
  let { me }: AuthContext = getContext(ContextTokens.Auth);

  $: notifyPage($hubStore, $me);

  function notifyPage(hubStore: HubService | null, user: UserSummary | null) {
    if (hubStore) {
      hubStore.activeUser = user;
      hubStore.activeLocation = pageUrl;

      if (user) 
      {
        hubStore.joinPage(pageUrl, user);
      }
    }
  }
</script>
